<template>
  <div @click="close" v-if="visible" class="share">
    <img src="https://picbed.qunarzz.com/60da80e3f4a84db2d02cb351687fb2ae.png" alt="">
  </div>
</template>
<script>
import dialogComp from "@/components/dialog/index.vue";
export default {
  data() {
    return {
      ownInfo: {},
      visible:false
    };
  },
  components: {
    dialogComp,
  },
  methods: {
    show() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  },
};
</script>

<style lang="less" scoped="true">
  .share{
    width:100%;
    height:100%;
    position: fixed;
    left:0;
    top:0;
    background-color: rgba(0,0,0,.6);
    img{
      width:270px;
      margin-left:auto;
      margin-right:auto;
      display: block;
      margin-top:50px;
    }
  }
</style>